import { NewsPosts } from '@dehaat/kisan-app-bl/models/PostsV2';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import { useSwiper } from 'swiper/react';
import styles from '@/styles/TruncateContent.module.css';
import CaretDownIcon from '../icons/CaretDownIcon';
import LazyImage from '../LazyImage';
import Paragraph, { VARIANT as PARAGRAPH_VARIANT } from '../Paragraph';
import SubHeading, { VARIANT as HEADING_VARIANT } from '../SubHeading';
import WhatsAppShare, { ICON_VARIANT } from '../WhatsAppShare';
interface Props {
  news: NewsPosts;
  nextNews: NewsPosts;
}
const NewsFeed = ({
  news,
  nextNews
}: Props) => {
  const {
    t
  } = useTranslation('news');
  const [origin, setOrigin] = useState('');
  const swiper = useSwiper();
  const {
    locale
  } = useRouter();
  const {
    attachments,
    content
  } = news;

  // Redirecting to whatsapp changes origin in android devices, so storing it beforehand to avoid incorrect whatsapp url sharing

  useEffect(() => {
    setOrigin(window.location.href);
  }, []);
  return <div className="relative h-screen pt-18" data-sentry-component="NewsFeed" data-sentry-source-file="NewsFeed.tsx">
      <div className="relative max-w-md sm:h-64 h-[30%] m-auto">
        <LazyImage alt={news.name || ''} fallBackIcon={<div className="bg-neutral-300 h-full flex items-center justify-center overflow-hidden px-4 w-full">
              {news.name && <span>{news.name}</span>}
            </div>} imageUrl={attachments.images[0]} className="h-full w-full" data-sentry-element="LazyImage" data-sentry-source-file="NewsFeed.tsx" />

        <WhatsAppShare message={`${t('whatsapp_news_share_text')}\n\n ${news.name || 'news'} \n\n ${origin}/${locale}/news?element_id=${news.id}`} className="absolute -right-2 bottom-0.5 p-2 bg-primary-80 mx-0" iconVariant={ICON_VARIANT.TWO} data-sentry-element="WhatsAppShare" data-sentry-source-file="NewsFeed.tsx" />
      </div>

      <div className="px-4">
        {news.name && <SubHeading variant={HEADING_VARIANT.LARGE} className="mt-4 mb-2">
            {news.name}
          </SubHeading>}
        <div dangerouslySetInnerHTML={{
        __html: content
      }} className={`${styles.multiline_truncate}`} />

        <Link href={attachments.source_link} target="_blank" className="flex font-nato-semibold items-center text-sm text-primary-100 underline whitespace-nowrap mt-6" data-sentry-element="Link" data-sentry-source-file="NewsFeed.tsx">
          {t('view_more_news')}
          <div className="bg-secondary-one-100 inline-block ml-1.5 p-1 rounded-full">
            <CaretDownIcon className="fill-transparent h-3 -rotate-90 stroke-2 stroke-white w-3" data-sentry-element="CaretDownIcon" data-sentry-source-file="NewsFeed.tsx" />
          </div>
        </Link>
      </div>

      {nextNews && <div style={{
      background: `linear-gradient(180deg, rgba(16, 16, 16, 0) 0%, rgba(16, 16, 16, 0.65) 32.01%, rgba(16, 16, 16, 0.65) 100%), url(${nextNews.attachments.images[0]})`,
      backgroundPosition: 'center'
    }} className="w-full md:h-20 flex justify-center flex-col items-center gap-2 py-4 px-2 absolute sm:bottom-0 bottom-[50px]">
          <Paragraph className="text-center pt-2 text-secondary-one-80" variant={PARAGRAPH_VARIANT.MEDIUM}>
            {nextNews?.name}
          </Paragraph>
          <button onClick={() => swiper.slideNext()} className="flex bg-secondary-one-80 rounded-2xl p-4 h-6 w-fit items-center gap-2 text-primary-110 font-nato-semibold text-sm">
            {t('scroll_down')}
            <CaretDownIcon className="h-4 w-4 fill-transparent stroke-primary-110 stroke-2 shrink-0" />
          </button>
        </div>}
    </div>;
};
export default NewsFeed;